export default __webpack_public_path__ + "static/media/react.f3285e33.png";